import {  FunctionComponent, useEffect } from "react";
import { Button } from "reactstrap";
import {
  Primary,
  Simple,
  AddCatalog,
  AcceptCatalog,
  CancelCatalog,
  PlusCatalog,
  AcceptConfirmation,
  CancelConfirmation,
  Secondary,
} from "./styled.components";

import "../../assets/css/buttons/index.css";
import { useSelector } from "react-redux";
type ButtonsProps = {
  title: string;
  handleClick?: Function;
  type: string;
  config?: any | null;
  visible?: boolean;
  children?: any;
  height?: number;
  width?: number;
  onKeyDown?: (e: any) => void;
  tabIndex?: number;
};

const Buttons: FunctionComponent<ButtonsProps> = ({
  title,
  handleClick,
  type,
  config,
  visible = true,
  children,
  height,
  width,
  onKeyDown,
  tabIndex,
}) => {
  const { btn } = useSelector((state: any) => state.theme);

  if (type === "primary") {
    return (
      <Primary
        bg={config ? config?.background : btn?.primary.background}
        color={config ? config?.textColor : btn?.primary.textColor}
        height={height}
        width={width}
        onClick={() => {
          handleClick && handleClick();
        }}
      >
        {title || "Button"}
      </Primary>
    );
  }

  if (type === "secondary") {
    return (
      <Secondary
        bg={config ? config?.background : btn?.secondary.background}
        color={config ? config?.textColor : btn?.secondary.textColor}
        height={height}
        width={width}
        onClick={() => {
          handleClick && handleClick();
        }}
      >
        {title || "Button"}
      </Secondary>
    );
  }
  if (type === "simple") {
    return (
      <Simple
        bg={config ? config?.background : btn?.primary.textColor}
        height={height}
        color={config ? config?.textColor : btn?.primary.textColor}
        onClick={() => {
          handleClick && handleClick();
        }}
        className={"btn-simple"}
      >
        {title || "Button"}
      </Simple>
    );
  }

  if (type === "login") {
    return (
      <Button
        style={{ height }}
        onClick={() => {
          handleClick && handleClick();
        }}
        className={"btn-login"}
        onKeyDown={onKeyDown}
        tabIndex={tabIndex}
      >
        {title || "Button"}
      </Button>
    );
  }

  if (type === "link") {
    return (
      <Button
        onClick={() => {
          handleClick && handleClick();
        }}
        className={"btn-link"}
      >
        {title || "Button"}
      </Button>
    );
  }

  if (type === "add-catalog") {
    return (
      <AddCatalog
        bg={config ? config?.background : btn?.primary.textColor}
        color={config ? config?.textColor : btn?.primary.textColor}
        onClick={() => {
          handleClick && handleClick();
        }}
        className={"btn-add-catalog"}
      >
        {title || "Button"}
      </AddCatalog>
    );
  }

  if (type === "accept-catalog") {
    return (
      <AcceptCatalog
        bg={config ? config?.background : btn?.primary.textColor}
        visible={visible}
        color={config ? config?.textColor : btn?.primary.textColor}
        onClick={() => {
          handleClick && handleClick();
        }}
        className={"btn-accept-catalog"}
      >
        {title || "Button"}
      </AcceptCatalog>
    );
  }

  if (type === "cancel-catalog") {
    return (
      <CancelCatalog
        bg={config ? config?.background : btn?.primary.textColor}
        visible={visible}
        color={config ? config?.textColor : btn?.primary.textColor}
        onClick={() => {
          handleClick && handleClick();
        }}
        className={"btn-cancel-catalog"}
      >
        {title || "Button"}
      </CancelCatalog>
    );
  }

  if (type === "plus-catalog") {
    return (
      //@ts-ignore
      <PlusCatalog
        //@ts-ignore
        bg={config ? config?.background : btn?.primary.textColor}
        visible={visible}
        color={config ? config?.textColor : btn?.primary.textColor}
        onClick={() => {
          handleClick && handleClick();
        }}
        //@ts-ignore
        className={"btn-plus-catalog"}
        //@ts-ignore
        children={children}
      ></PlusCatalog>
    );
  }

  if (type === "accept-confirmation") {
    return (
      <AcceptConfirmation
        bg={config ? config?.background : btn?.primary.textColor}
        visible={visible}
        color={config ? config?.textColor : btn?.primary.textColor}
        onClick={() => {
          handleClick && handleClick();
        }}
        className={"btn-accept-confirmation"}
      >
        {title || "Button"}
      </AcceptConfirmation>
    );
  }

  if (type === "cancel-confirmation") {
    return (
      <CancelConfirmation
        bg={config ? config?.background : btn?.primary.textColor}
        visible={visible}
        color={config ? config?.textColor : btn?.primary.textColor}
        onClick={() => {
          handleClick && handleClick();
        }}
        className={"btn-cancel-confirmation"}
      >
        {title || "Button"}
      </CancelConfirmation>
    );
  }

  return null;
};

export default Buttons;
